import React from "react";
import { panelSubsectionTitleClassName } from "../propertyPanelUtils";

type SubsectionTitleProps = {
  children: React.ReactNode;
  className?: string;
};

/**
 * Quiet group header for property panel blocks (Sizing, Table, Seating, etc.).
 */
const SubsectionTitle: React.FC<SubsectionTitleProps> = ({
  children,
  className = "",
}) => (
  <div className={`${panelSubsectionTitleClassName} ${className}`.trim()}>
    {children}
  </div>
);

export default SubsectionTitle;
